import type { HeaderFeatures } from './type';

export const header: HeaderFeatures = {
    customerEntities: {
        enabled: true,
    },
    plugins: {
        enabled: true,
        _description: 'Display/hide "Your Extras" option in the main navigation.',
        searchAndBuyPromo: {
            enabled: true,
        },
    },
};
